/** The sections of the page that the header and the footer link to (their `id`s are the anchors). */
export const SECTION_IDS = ['boards', 'databases', 'calendar', 'teamwork'] as const;
export type SectionId = (typeof SECTION_IDS)[number];
